var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c('main-last-played',{attrs:{"showAbout":_vm.showAbout},on:{"close-about":_vm.closeAbout,"open-signup":_vm.openSignup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }